/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Home Page Bifold Section
// Initializing slick-slider for mobile

(function($) { 
  $(document).ready(function(){ 
    if ($(window).width()<1008) {
      $('.bifold .ProductList--carousel').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        prevArrow: $('.s-prev'),
        nextArrow: $('.s-next'),
        responsive: [
          {
            breakpoint: 641,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
      });
    }
    
    $('.AnnouncementBar__Wrapper').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 4000
    });
    
    

    // JACK STORY PAGE  hero background parallax 
    if ($(window).width()>1008) {
      var initScrollTop = $(window).scrollTop();
      var $parall = $('.jack-story-hero .section-hero');
      
      $parall.css({'background-position-y' : (initScrollTop/75)+'%'});
      
      $(window).scroll(function() {    
        var scrollTop = $(window).scrollTop();
        $parall.css({'background-position-y' : (scrollTop/75)+'%'});    
      });
    }
    
    
    // var CollapsBtn=$('#collection-filter-drawer .Collapsible__Button');
    // $('.CollectionFilters .Drawer__Main .Collapsible:first-child .Collapsible__Inner').addClass('show');
    
    /* 
    CollapsBtn.click(function(){
      if($(this).next().hasClass('show')) {
        $(this).next().removeClass('show').slideUp('350');
      } else {
        CollapsBtn.next().removeClass('show').slideUp('350');
        $(this).next().toggleClass('show').slideToggle('350');
      }
    });
    */
    
    $(`.personalization-options`).on('change', function(event) {
      var $selector = $(this)

      if ( $selector.val() != null && $selector.val() != "" ) { 
        $('.personalization-text').show()
        
        if ( $selector.val() == "Interior Stamped Name (Character Limit 8)" ) { 
          $(`.personalization-text-limit`).text('8');

          $(`#personalization-text`).val('');
          $(`#personalization-text`).attr(`maxlength`, 8);
        } else if ($selector.val() == "Exterior Monogram (First, Last)") {
          $(`.personalization-text-limit`).text('2');

          $(`#personalization-text`).val('');
          $(`#personalization-text`).attr(`maxlength`, 2);
        } else {
          $(`.personalization-text-limit`).text('3');

          $(`#personalization-text`).val('');
          $(`#personalization-text`).attr(`maxlength`, 3);
        }
      } else {
        $('.personalization-text').hide()
        $(`.personalization-wrapper`).removeClass('has-errors')
      }
    });

    $(`.js-personalize-product`).off('click').on('click', function(event) {
      var $parent = $(this).closest(`[data-section-type="product"]`);
      var options = $parent.data(`section-settings`);

      if (!options['useAjaxCart']) {
        return; // When using a cart type of page, we just simply redirect to the cart page
      }

      event.preventDefault(); // Prevent form to be submitted

      var $addToCartButton = $parent.find('.ProductForm__AddToCart');

      // First, we switch the status of the button
      // $addToCartButton.attr('disabled', 'disabled');
      // document.dispatchEvent(new CustomEvent('theme:loading:start'));

      // Then we add the product in Ajax
      var $formElement = $parent.find('form[action*="/cart/add"]');
      
      var bundleID = Date.now();
      var formData = new FormData($formElement[0]).entries();
      var formObj  = {};

      // Build the payload so that `properties[Name]` inputs (e.g. Estimated Ship Date)
      // end up in a nested `properties` object, which is what /cart/add.js expects for JSON
      Array.from(formData).forEach(([key, value]) => {
        var propertyMatch = key.match(/^properties\[(.+)\]$/);

        if (propertyMatch) {
          formObj.properties = formObj.properties || {};
          formObj.properties[propertyMatch[1]] = value;
        } else {
          formObj[key] = value;
        }
      });

      const cartData = {
        items: []
      };

      if ( $formElement.find(`.personalization-options`).length && $formElement.find(`.personalization-options`).val() != null && $formElement.find(`.personalization-options`).val() != "" ) {
        if ( $formElement.find(`#personalization-text`).val() == '' ) {
          $formElement.find(`.personalization-wrapper`).addClass('has-errors');

          return;
        }

        // Merge so existing form properties (e.g. Estimated Ship Date) are kept
        formObj.properties = Object.assign({}, formObj.properties, {
          "Personalization Option": $formElement.find(`.personalization-options`).val(),
          "Personalization Text": $formElement.find(`#personalization-text`).val().toUpperCase(),
          _bundleId: bundleID
        });

        /*
        if ( $formElement.find(`.personalization-options`).val() == "Interior Stamped Monogram (First, Middle, Last)" ) {
          formObj.properties["Personalization Option 2"] = "Interior Stamped Name"
          formObj.properties["Personalization Text 2"] = $formElement.find(`#personalization-text-2`).val().toUpperCase()
        }
        */

        cartData.items.push(formObj);

        cartData.items.push({
          id: 43694425637108,
          quantity: 1,
          properties: {
            _bundleId: bundleID
          }
        });
      } else { 
        cartData.items.push(formObj);
      }

      // console.log(cartData);
      // return;

      fetch(window.routes.cartAddUrl + '.js', {
        body: JSON.stringify(cartData),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
      }).then(function (response) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        if (response.ok) {
          $addToCartButton.removeAttr('disabled');
          // We simply trigger an event so the mini-cart can re-render
          $parent[0].dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              // variant: _this8.currentVariant,
              quantity: parseInt($formElement.find('[name="quantity"]').val())
            }
          }));
        } else {
          response.json().then(function (content) {
            var errorMessageElement = document.createElement('span');
            errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
            errorMessageElement.innerHTML = content['description'];

            $addToCartButton.removeAttr('disabled');
            $addToCartButton[0].insertAdjacentElement('afterend', errorMessageElement);
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
          });
        }
      });
    });
    
    $('body')
    .on('click', '.ProductMeta__Reviews.yotpo .standalone-bottomline .star-clickable', function(e) {
      e.preventDefault();
      
      var $triggerElem = $('.Product_Reviews__CollapBtn');
      if ( $triggerElem.attr('aria-expanded') == "false" ) {
        $triggerElem.trigger('click');
      }
    });

  });
})(jQuery);

